export default __webpack_public_path__ + "static/media/home_authentication_bg.448530f4.png";